

































import {
  Vue,
  Component,
  Prop,
  Watch,
  Emit,
  PropSync
} from 'vue-property-decorator'

@Component
export default class InstantMatchTournamentInformationDialog extends Vue {
  @PropSync('visible', { required: true }) isVisible!: boolean
  @Prop({ default: '' }) header!: string

  @Emit('close')
  close() {
    this.isVisible = false
    return this
  }

  @Watch('isVisible')
  onVisibilityChanged(value: boolean) {
    if (!value) {
      this.close()
    }
  }
}
